module.exports = __webpack_public_path__ + "img/sport5.90023d50.png";